import { useGetFileQuery } from 'services';
export function useFile(fileId?: number) {
  const {
    data: file,
    isError,
    isLoading,
    error
  } = useGetFileQuery(fileId!, {
    skip: !fileId,
    refetchOnMountOrArgChange: true
  });

  return {
    isError,
    isLoading,
    error,
    file: file?.data
  };
}
